import React from 'react';
import { Card, Typography } from '@/shared/antd-imports';

const { Title } = Typography;

const ChatDetailsPage: React.FC = () => {
  return (
    <Card>
      <Title level={2}>Chat Details</Title>
      <p>Chat details page coming soon...</p>
    </Card>
  );
};

export default ChatDetailsPage; 